"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegExpEmail = void 0;
exports.RegExpCheckEmail = RegExpCheckEmail;
exports.RegExpEmail = new RegExp(/^(([^<>()\[\]\.,;:\s@"]+(.[^<>()\[\]\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}])|(([a-zA-Z\-0-9]+.)+[a-zA-Z]{2,}))$/);
function RegExpCheckEmail(emailToCheck) {
    return exports.RegExpEmail.test(emailToCheck ?? '') && (emailToCheck ?? '') !== '';
}
